// extracted by mini-css-extract-plugin
export default {"prices":"pricing_prices__XyhQ3","h2":"pricing_h2__73oiV"};